
const stateCode = {
  0: '成功',
  10000: '参数错误',
  10003: '禁止访问',
  10004: '资源不存在',
  10010: '认证失败',
  10020: '令牌失效',
  10030: '令牌过期',
  10100: 'refreshToken异常'
}

export default stateCode
